/* eslint-disable @nx/enforce-module-boundaries */
import { Pipe, PipeTransform } from '@angular/core';
import { SortingCriteria, SortDirection } from '@lx/shared/types';
import { sortArray } from '@lx/shared/utils-array';

@Pipe({ name: 'lxSortBy', standalone: true })
export class SortByPipe implements PipeTransform {
  transform<T>(originalArray: T[], sortCriteria: SortingCriteria<T> | SortDirection = 'asc'): T[] {
    return sortArray<T>(originalArray, sortCriteria);
  }
}
